import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";


let redux = reduxCreator.type('USER_CONFIRM_EMAIL').plugin(axiosPlugin);

let confirmEmailAction = redux.fetchActionCreate();

export const TYPES = redux.types;

export const fetchConfirmEmail = (data = {}) => confirmEmailAction(`/users/accounts/verify-email`, data);

export const userConfirmEmail = redux.reducer();